import { render, staticRenderFns } from "./BookLessonItem.vue?vue&type=template&id=57bf24e2&scoped=true&"
import script from "./BookLessonItem.vue?vue&type=script&lang=js&"
export * from "./BookLessonItem.vue?vue&type=script&lang=js&"
import style0 from "./BookLessonItem.vue?vue&type=style&index=0&id=57bf24e2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bf24e2",
  null
  
)

export default component.exports